/* eslint-disable no-unused-vars */
import {Transaction} from '@/plugins/api'
import axios from 'axios'
export default {
  namespaced: true,
  state: {
    filterParams: {},
    items: [],
    count: 0,
    //
    banks: [],
  },
  actions: {
    async fetchItems({commit, state}, params = {}) {
      const filterParams = {...state.filterParams, ...params}
      const items = await Transaction.fetch({...filterParams})
      commit('changeState', {filterParams, items})
    },
    async countItems({commit, state}, params = {}) {
      const {_sort, populates, ...filterParams} = {...state.filterParams, ...params}
      const count = await Transaction.count({...filterParams})
      commit('changeState', {count})
    },
    fetchItemsIndependent({state}, options = {}) {
      const filterParams = {...state.filterParams, ...options}
      return Transaction.fetch(filterParams)
    },
    async fetchBanks({commit}) {
      const res = await axios.get('https://api.vietqr.io/v2/banks')
      commit('changeState', {banks: res.data})
    },
  },
  getters: {
    items: state => state.items,
    count: state => state.count,
    //
    banks: state => state.banks,
  },
}
